import { Component, Vue } from 'vue-property-decorator';
import { DisplayEnum } from '@/types/enum';
import { SearchParams, FilterDataType, AllFilterDateMapping } from '@/types/product';
import { GridProps } from '@/types/board';
import { changeDateFormat } from '@/utils/dateUtils';
import { Mall, Brand, ContractedPartner, Mds, CustomProperty, ProductsSearch, ProductsDetailUrl } from 'supporter';
import {
  escapeHtml,
  getCurrency,
  centerWinOptions,
  productNameConvertor,
  convertProductUri,
  getLocalStorageMalls,
} from '@/utils/commonUtils';
import { namespace } from 'vuex-class';
import {
  ProductNameEditor,
  MemberGradeDisplayInfoRenderer,
  MemberGroupDisplayInfoRenderer,
} from '@/components/product/ProductListGridClass';
const termsModule = namespace('terms');
import { toI18n } from '@/utils/commonUtils';

@Component
export default class ProductListDataMixin extends Vue {
  @termsModule.Mutation('SET_NCPLAYERISEXIST') public setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') public setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') public setPopInfo!: (popInfo: {}) => void;

  public invalidKeywordSwitch = false;
  public invalidKeywordText = '';
  public pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }
  public readonly ALERT_MESSAGES = {
    chooseMall: this.pDI18n('PLD_PLEASE_SELECT_A_SHOPPING_MALL_FIRST'), //
  };

  public searchParams: SearchParams = {
    mallNos: '',
    'keywordInfo.type': 'MALL_PRODUCT_NO',
    'keywordInfo.keywords': '',
    brandNo: -100,
    partnerNo: -100,
    adminNo: -100,
    applyStatusType: 'ALL',
    'saleStatus.isAll': false,
    'saleStatus.types': '',
    'saleSettingStatus.isAll': false,
    'saleSettingStatus.types': '',
    // excludeSalesEndProduct: true,
    'categoryCondition.type': 'DISPLAY',
    'categoryCondition.depth': '',
    'categoryCondition.no': '',
    'stockRange.type': 'ALL',
    // 'stockRange.stockCnt': -1,
    allowsPromotion: 'ALL',
    allowsFrontDisplay: 'ALL',
    // canApplyCoupon: '',
    // canApplyAdditionalDiscount: '',
    needsAdditionalDiscountInfo: 'N',
    platformType: 'ALL',
    saleMethodType: 'ALL',
    'commission.type': 'ALL',
    'commission.range.min': 0,
    'commission.range.max': 100,
    exceptedMallProductNos: -100,
    memberGradeNo: '',
    memberGroupNo: '',
    shippingAreaType: 'ALL',
    onlyAccessUrl: '',
    remainsSaleDays: 0,
    allowsShippingTogether: '',
    onlyMappingProduct: 'ALL',
    deliveryFeeType: 'ALL',
    'periodInfo.type': 'REGISTER_DATE',
    'periodInfo.period.startYmdt': '',
    'periodInfo.period.endYmdt': '',
    onlyParentProduct: '',
    customPropertyValueNos: '',
    page: 1,
    size: 100,
  };

  public searchParamsResetData = { ...this.searchParams };

  public searchRespones: ProductsSearch = {
    contents: [],
    totalPage: 0,
    totalCount: 0,
  };

  public DEFAULT_MIN_DATE_RANGE = '2000-01-01';

  public applyStatusType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_APPROVAL_STATUS') }, //
    { value: 'REGISTRATION_READY', label: this.pDI18n('PLD_WAITING_FOR_REGISTRATION') }, //
    { value: 'APPROVAL_READY', label: this.pDI18n('PLD_WAITING_FOR_APPROVAL') }, //
    { value: 'APPROVAL_REJECTION', label: this.pDI18n('PLD_REJECTION_OF_APPROVAL') }, //
    { value: 'SALE_AGREEMENT_READY', label: this.pDI18n('PLD_WAITING_FOR_SALES_AGREEMENT') }, //
    { value: 'SALE_AGREEMENT_REJECTION', label: this.pDI18n('PLD_REJECTION_OF_SALES_AGREEMENT') }, //
    { value: 'FINISHED', label: this.pDI18n('PLD_APPROVAL_COMPLETED') }, //
    { value: 'AFTER_APPROVAL_READY', label: this.pDI18n('PLD_WAITING_FOR_APPROVAL_AFTER_MODIFICATION') }, //
    { value: 'AFTER_APPROVAL_REJECTION', label: this.pDI18n('PLD_REJECT_APPROVAL_AFTER_MODIFICATION') }, //
  ];
  public searchType: DisplayEnum[] = [
    { value: 'MALL_PRODUCT_NO', label: this.pDI18n('PLD_PRODUCT_NUMBER') }, //
    { value: 'PRODUCT_NAME', label: this.pDI18n('PLD_PRODUCT_NAME') }, //
    { value: 'PRODUCT_MANAGEMENT_CD', label: this.pDI18n('PLD_PRODUCT_MANAGEMENT_CODE') }, //
    { value: 'PRODUCT_MANAGEMENT_CD_LIKE', label: this.pDI18n('PLD_PRODUCT_MANAGEMENT_CODE_PARTIAL_SEARCH') }, //
    { value: 'GROUP_MANAGEMENT_CODE', label: this.pDI18n('PLD_GROUP_MANAGEMENT_CODE') }, //
  ];

  //periodInfo.type * in the new api, searchDateType in the old api
  public searchDateType: DisplayEnum[] = [
    { value: 'REGISTER_DATE', label: this.pDI18n('PLD_PRODUCT_REGISTRATION_DATE') }, //
    { value: 'PRE_SALE_START_DATE', label: this.pDI18n('PLD_START_DATE_OF_PRE_ORDER') }, //
    { value: 'PRE_SALE_END_DATE', label: this.pDI18n('PLD_END_OF_SALES_BY_SUBSCRIPTION') }, //
    { value: 'SALE_START_DATE', label: this.pDI18n('PLD_SALES_START_DATE') }, //
    { value: 'SALE_END_DATE', label: this.pDI18n('PLD_SALE_END_DATE') }, //
    { value: 'PRODUCT_MODIFIED_DATE', label: this.pDI18n('PLD_LAST_MODIFIED_DATE') }, //
  ];

  public categoryType: DisplayEnum[] = [
    { value: 'DISPLAY', label: this.pDI18n('PLD_EXHIBITION_CATEGORY') }, //
    { value: 'STANDARD', label: this.pDI18n('PLD_STANDARD_CATEGORY') }, //
  ];

  public filterDateData: FilterDataType[] = [
    { value: '0', label: this.$t('BOARD_FAQ_TODAY') as string, selected: false }, // 오늘
    { value: '1w', label: this.$t('BOARD_FAQ_1WEEK') as string, selected: false }, // 1주일
    { value: '1m', label: this.$t('BOARD_FAQ_1MONTH') as string, selected: false }, // 1개월
    { value: '3m', label: this.$t('BOARD_FAQ_3MONTHS') as string, selected: true }, // 3개월
    { value: '6m', label: this.$t('BOARD_FAQ_6MONTHS') as string, selected: false }, // 6개월
    { value: '1y', label: this.$t('BOARD_FAQ_1YEAR') as string, selected: false }, // 1년
    { value: 'ALL', label: this.$t('BOARD_FAQ_ALL') as string, selected: false }, // 전체
  ];

  public filterDateMapping: AllFilterDateMapping = {
    '0': [0, 'd'],
    '1w': [-7, 'd'],
    '1m': [-1, 'M'],
    '3m': [-3, 'M'],
    '6m': [-6, 'M'],
    '1y': [-1, 'y'],
    ALL: [100, ''],
  };

  public filterDateAddMapping: AllFilterDateMapping = {
    '0': [0, 'd'],
    '1w': [7, 'd'],
    '1m': [1, 'M'],
    '3m': [3, 'M'],
    '6m': [6, 'M'],
    '1y': [1, 'y'],
    ALL: [100, ''],
  };

  public platformType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_PLATFORM_CLASSIFICATION') }, //
    { value: 'PC', label: 'PC' },
    { value: 'MOBILE_APP', label: this.pDI18n('PLD_MOBILE_APP') }, //
    { value: 'MOBILE_WEB', label: this.pDI18n('PLD_MOBILE_WEB') }, //
  ];

  //old api named: urlDirectDisplayYn
  public onlyAccessUrl: DisplayEnum[] = [
    { value: '', label: this.pDI18n('PLD_WHETHER_FRONT_EXPOSURE') }, //
    { value: 'N', label: this.pDI18n('PLD_FRONT_EXPOSURE') }, //
    { value: 'Y', label: this.pDI18n('PLD_FRONT_UNEXPOSED') }, //
  ];

  public memberGradeNo: DisplayEnum[] = [{ value: '', label: this.pDI18n('PLD_MEMBERSHIP_LEVEL_EXPOSURE') }]; //

  public memberGroupNo: DisplayEnum[] = [{ value: '', label: this.pDI18n('PLD_MEMBER_GROUP_EXPOSURE') }]; //
  //stockRange.type: NONE:'0', EXIST:'1', LE: 1 5 10 50 100 (stockRange.stockCnt)
  public stockRange: DisplayEnum[] = [
    { value: '-1', label: this.pDI18n('PLD_AVAILABILITY') }, //
    { value: '0', label: this.pDI18n('PLD_NO_STOCK') }, //
    { value: '1', label: this.pDI18n('PLD_IN_STOCK') }, //
    { value: '5', label: this.pDI18n('PLD_N5_OR_LESS') }, //
    { value: '10', label: this.pDI18n('PLD_N10_OR_LESS') }, //
    { value: '50', label: this.pDI18n('PLD_N50_OR_LESS') }, //
    { value: '100', label: this.pDI18n('PLD_N100_OR_LESS') }, //
  ];

  public remainsSaleDays: DisplayEnum[] = [
    { value: '0', label: this.pDI18n('PLD_REMAINING_SALES_PERIOD') }, //
    { value: '3', label: this.pDI18n('PLD_N3_DAYS') }, //
    { value: '7', label: this.pDI18n('PLD_N7_DAYS') }, //
    { value: '15', label: this.pDI18n('PLD_N15TH') }, //
    { value: '30', label: this.pDI18n('PLD_N30_DAYS') }, //
  ];

  public saleMethodType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_SALES_METHOD') }, //
    { value: 'PURCHASE', label: this.pDI18n('PLD_BUY') }, //
    { value: 'CONSIGNMENT', label: this.pDI18n('PLD_CONSIGNMENT') }, //
  ];

  public shippingAreaType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_SHIPPING_CLASSIFICATION') }, //
    { value: 'PARTNER_SHIPPING_AREA', label: this.pDI18n('PLD_PARTNER_DELIVERY') }, //
    { value: 'MALL_SHIPPING_AREA', label: this.pDI18n('PLD_SHOPPING_MALL_SHIPPING') }, //
  ];
  //old api: deliveryConditionType
  public deliveryFeeType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_SHIPPING_COST_TYPE') }, //
    { value: 'FREE', label: this.pDI18n('PLD_FREE') }, //
    { value: 'CONDITIONAL_FREE', label: this.pDI18n('PLD_CONDITIONALLY_FREE') }, //
    { value: 'FIXED_FEE', label: this.pDI18n('PLD_PAID_FIXED_SHIPPING_FEE') }, //
  ];
  //old api: deliveryCombinationYn
  public allowsShippingTogether: DisplayEnum[] = [
    { value: '', label: this.pDI18n('PLD_BUNDLED_SHIPPING') }, //
    { value: 'Y', label: this.pDI18n('PLD_POSSIBLE') }, //
    { value: 'N', label: this.pDI18n('PLD_IMPOSSIBLE') }, //
  ];
  //old api: promotionYn
  public allowsPromotion: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_WHETHER_PROMOTION') }, //
    { value: 'Y', label: this.pDI18n('PLD_POSSIBLE') }, //
    { value: 'N', label: this.pDI18n('PLD_IMPOSSIBLE') }, //
  ];
  //old api: frontDisplayYn
  public allowsFrontDisplay: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_EXHIBITION_STATUS') }, //
    { value: 'Y', label: this.pDI18n('PLD_DISPLAY_POSSIBLE') }, //
    { value: 'N', label: this.pDI18n('PLD_NO_EXHIBITION') }, //
  ];
  //cascade with commission.range.min & commission.range.max
  public commissionType: DisplayEnum[] = [
    { value: 'ALL', label: this.pDI18n('PLD_ALL') }, //
    { value: 'RATE', label: this.pDI18n('PLD_COMMISSION_RATE') }, //
    { value: 'SUPPLY_PRICE', label: this.pDI18n('PLD_SUPPLY_PRICE') }, //
  ];

  public today: string = changeDateFormat('', 'YYYY-MM-DD');

  public productDetailUrlObj: ProductsDetailUrl[] = [];
  public get malls(): DisplayEnum[] {
    return getLocalStorageMalls().map(
      (mall: Mall): DisplayEnum => {
        return { value: mall.mallNo.toString(), label: mall.mallName };
      },
    );
  }

  public get USMallNos(): Mall[] {
    return (
      getLocalStorageMalls()
        .filter((mall: Mall) => mall.countryCode === 'US')
        .map(mall => mall.mallNo) || []
    );
  }

  public productsSummaries = {
    totalCnt: 0,
    onSaleCnt: 0,
    readyCnt: 0,
    soldOutCnt: 0,
    approvalReadyCnt: 0,
    approvalRejectionCnt: 0,
    saleAgreementRejectionCnt: 0,
    stopCnt: 0,
  };

  public isAllCheckBoxDisabled = false;
  public saleStatusData: string[] = ['ON_PRE_SALE', 'WAITING_SALE', 'ON_SALE', 'END_SALE'];
  public saleSettingStatusData: string[] = ['AVAILABLE_FOR_SALE', 'STOP_SELLING', 'PROHIBITION_SALE'];
  public saleStatusList: DisplayEnum[] = [
    { value: 'ON_PRE_SALE', label: this.pDI18n('PLD_PRE_ORDER') }, //
    { value: 'WAITING_SALE', label: this.pDI18n('PLD_WAITING_FOR_SALE') }, //
    { value: 'ON_SALE', label: this.pDI18n('PLD_SALE') }, //
    { value: 'END_SALE', label: this.pDI18n('PLD_END_OF_SALE') }, //
  ];

  public saleSettingStatusList: DisplayEnum[] = [
    { value: 'AVAILABLE_FOR_SALE', label: this.pDI18n('PLD_AVAILABLE_FOR_SALE') }, //
    { value: 'STOP_SELLING', label: this.pDI18n('PLD_STOP_SELLING') }, //
    { value: 'PROHIBITION_SALE', label: this.pDI18n('PLD_PROHIBITION_OF_SALE') }, //
  ];

  public keywordTexthide: boolean = true;

  public popInfo = {
    // eslint-disable-next-line quotes
    title: `${this.pDI18n('PLD_COMMONMSG1')}`,
    subStyle: 'width:620px; max-height:800px; scroll-y:auto',
    noticeBox: `
<div class="notice_box no_mark">
  <p>${this.pDI18n('PLD_COMMONMSG2')}</p>
    <ul>
      <li>
          <div><b>[${this.pDI18n('PLD_COMMONMSG3')}]</b> ${this.pDI18n('PLD_COMMONMSG4')}</div>
      </li>
      <li>
          <div><b>[${this.pDI18n('PLD_COMMONMSG5')}]</b> ${this.pDI18n('PLD_COMMONMSG6')}</div>
      </li>
      <li>
          <div><b>[${this.pDI18n('PLD_COMMONMSG7')}]</b> ${this.pDI18n('PLD_COMMONMSG8')}</div>
      </li>
    </ul>
</div>`,
  };

  public brandsList: Brand[] = [];
  public brandsInputVal: string = '';
  public brandsMenuIsShow = false;

  public partnerList: ContractedPartner[] = [];
  public partnerInputVal: string = '';
  public partnerMenuIsShow = false;

  public adminList: Mds[] = [];
  public adminInputVal: string = '';
  public adminMenuIsShow = false;

  public categoiesCascade: any;

  public isCommissionTypeDisabled = false;
  public isSupplyPriceViewShow = false;
  public isCommissionRateView = false;
  public customProperties: CustomProperty[] = [];

  public updateGrid(gridId: string, rowKey: any, newData: any): void {
    let tuiGrid = (this.$refs.gridArea as any).$refs.tuiGrid;
    if (gridId === 'tui-grid-productlistOfStockSync') {
      tuiGrid = (this.$refs.gridAreaOfStockSync as any).$refs.stockSyncTuiGrid;
    }
    const rowData = tuiGrid.invoke('getRow', rowKey);
    const newRowData = Object.assign({}, { ...rowData, ...newData });
    tuiGrid.invoke('setRow', rowKey, newRowData);
  }

  public gridModifyHandler({ data: { totalCount, successNos, failures } }): boolean {
    if (totalCount) {
      if (successNos && successNos.length) {
        alert(this.pDI18n('PLD_IT_IS_CHANGED')); //
        return true;
      }

      if (failures && failures.length) {
        alert(failures[0].message);
      }
    }
    return false;
  }

  private productNameOnChange(ev: any): void {
    const $this = $(ev.currentTarget);
    const gridId = $this
      .parents('.tui-grid-container')
      .last()
      .attr('id');

    if (this.searchRespones.contents && this.searchRespones.contents.length) {
      const currentRowData = { ...this.searchRespones.contents[ev.rowKey] };
      if (currentRowData.saleSettingStatusType !== 'PROHIBITION_SALE') {
        const productName = ev.value;
        const params = {
          mallProductNos: currentRowData.mallProductNo.toString(),
        };
        const data = {
          productName,
        };
        this.$api.patchProducts({ params, data }).then((data): void => {
          if (this.gridModifyHandler(data)) {
            this.updateGrid(gridId, ev.rowKey, { productName });
          }
        });
      }
    }
  }

  //public dontModifyStatus = ['FINISHED', 'PROHIBITION'];// ===> row.saleSettingStatusType === 'PROHIBITION_SALE'
  public doNotDeleteProduct = ['FINISHED', 'AFTER_APPROVAL_READY', 'AFTER_APPROVAL_REJECTION'];
  public dontCopyStatus = ['PROHIBITION'];
  public beforeApprovalStatus = [
    'REGISTRATION_READY',
    'APPROVAL_READY',
    'APPROVAL_REJECTION',
    'SALE_AGREEMENT_READY',
    'SALE_AGREEMENT_REJECTION',
  ];
  public customColumnHeader = {
    height: 40,
    columns: [
      {
        name: 'supplyPrice',
        renderer: ({ columnInfo }: any): any => {
          const div = document.createElement('div');
          const span = document.createElement('span');
          span.innerText = columnInfo.header;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'help';
          button.style.cssText = 'background: url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
          button.addEventListener('mousedown', (e): void => {
            const popInfo = {
              title: this.pDI18n('PLD_SUPPLY_PRICE_TITLE'),
              subStyle: 'width:620px; max-height:800px; scroll-y:auto',
              noticeBox: `
                <div class="notice_box noIcon">
                  <ul>
                    <div class="description">${this.pDI18n('PLD_SUPPLY_PRICE_1')}</div>
                    <div class="description">${this.pDI18n('PLD_SUPPLY_PRICE_2')}</div>
                    <div class="description">${this.pDI18n('PLD_SUPPLY_PRICE_3')}</div>
                  </ul>
                </div>`,
            };
            this.setPopInfo(popInfo);
            this.setPopIsShow(true);
            e.preventDefault();
            e.stopPropagation();
          });
          div.append(span, button);
          return {
            getElement(): any {
              return div;
            },
            render(): void {
              div.append(span, button);
            },
          };
        },
      },
      {
        name: 'onlyAccessUrl',
        renderer: ({ columnInfo }: any): any => {
          const div = document.createElement('div');
          const span = document.createElement('span');
          span.innerText = columnInfo.header;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'help';
          button.style.cssText = 'background: url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
          button.addEventListener('mousedown', (): void => {
            const popInfo = {
              title: this.pDI18n('PLD_COMMONMSG9'),
              subStyle: 'width:620px; max-height:800px; scroll-y:auto',
              noticeBox: `
<div class="notice_box noIcon">
<ul>
<div class="description">${this.pDI18n('PLD_COMMONMSG10')}</div>
<div class="description">${this.pDI18n('PLD_COMMONMSG11')}</div>
</ul>
</div>`,
            };
            this.setPopInfo(popInfo);
            this.setPopIsShow(true);
          });
          div.append(span, button);
          return {
            getElement(): any {
              return div;
            },
            render(): void {
              div.append(span, button);
            },
          };
        },
      },
      {
        name: 'stockCnt',
        renderer: ({ columnInfo }: any): any => {
          const div = document.createElement('div');
          div.innerHTML = columnInfo.header.split('&').join('<br>');
          return {
            getElement(): any {
              return div;
            },
            render(): void {},
          };
        },
      },
      {
        name: 'canPromotion',
        renderer: ({ columnInfo }: any): any => {
          const div = document.createElement('div');
          const span = document.createElement('span');
          span.innerText = columnInfo.header;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'help';
          button.style.cssText = 'background: url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
          button.addEventListener('mousedown', (): void => {
            const popInfo = {
              title: this.pDI18n('PLD_COMMONMSG12'),
              subStyle: 'width:620px; max-height:800px; scroll-y:auto',
              noticeBox: `
                        <div class="notice_box noIcon">
                        <ul>
                        <div class="description">${this.pDI18n('PLD_COMMONMSG13')}</div>
                        </ul>
                        </div>`,
            };
            this.setPopInfo(popInfo);
            this.setPopIsShow(true);
          });
          div.append(span, button);
          return {
            getElement(): any {
              return div;
            },
            render(): void {
              div.append(span, button);
            },
          };
        },
      },
    ],
  };

  public getProductDetailUrl({ value, row }: any): string {
    const { applyStatusType } = row;
    if (applyStatusType === 'REGISTRATION_READY') return row.mallProductNo;
    const uri = this.productDetailUrlObj.find(({ mallNo }) => mallNo === row.mallNo).url;
    const convertUri = convertProductUri(uri, value);

    const productUri = `<a target="_blank" href="${convertUri}">${value}</a>`;

    if (row.isStockSync) {
      if (row.parentMallProductNo === 0) {
        return `<a href="javascript:;" class="gridMasterProductBtn" data-mall-no="${row.mallNo}" data-mall-product-no="${row.mallProductNo}" data-parent_mall_product_no="${row.mallProductNo}">(M)</a> ${productUri}`;
      }
      return `<a href="javascript:;" class="gridMasterProductBtn" data-mall-no="${row.mallNo}" data-mall-product-no="${row.mallProductNo}" data-parent_mall_product_no="${row.parentMallProductNo}">(S)</a> ${productUri}`;
    }
    if (row.isItem) {
      return `<a href="javascript:;" class="gridItemProductBtn" data-mall-product-no="${row.mallProductNo}" data-parent_mall_product_no="${row.mallProductNo}">(W)</a> ${productUri}`;
    }
    return productUri;
  }

  public newColumnsCustomization: { [propName: string]: any } = [];
  public excelColumns: { [propName: string]: any } = [];
  public excelColumnsKeys = [
    'adminName',
    'appliedImmediateDiscountPrice',
    'applyStatusType',
    'brandName',
    'canPromotion',
    'commissionRate',
    'deliverable',
    'deliveryCharge',
    'deliveryFeeType',
    'displayCategoryNames',
    'frontDisplayable',
    'groupType',
    'immediateDiscountAmount',
    'mallName',
    'partnerName',
    'priceComparisonSite',
    'productManagementCd',
    'productName',
    'mallProductNo',
    'purchasePrice',
    'reservationPeriod',
    'reservationStockCnt',
    'saleCnt',
    'saleMethodType',
    'salePeriod',
    'salePrice',
    'saleStatusType',
    'saleSettingStatusType',
    'shippingAreaType',
    'usesDeliveryDueDate',
    'shippingCombinable',
    'stockCnt',
    'supplyPrice',
  ];
  public gridProps: GridProps = {
    columns: [
      {
        header: this.pDI18n('PLD_MODIFY'), //
        name: 'modifyBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          let text = this.pDI18n('PLD_MODIFY'); //
          if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
            text = this.pDI18n('PLD_EXAMPLE'); //
          }
          return `<a href="/product/edit/${row.mallProductNo}" target="_blank">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_COPY'), //
        name: 'copyBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.applyStatusType === 'REGISTRATION_READY' || row.optionType === 'MAPPING') {
            return '-';
          }
          if (row.saleSettingStatusType !== 'PROHIBITION_SALE' && row.parentMallProductNo === 0) {
            // itemYn ==> isItem
            const url = `/product/popup/copyMallProduct?mallNo=${row.mallNo}&mallProductNo=${
              row.mallProductNo
            }&saleStatusType=${row.saleStatusType}&itemYn=${row.isItem ? 'Y' : 'N'}`;
            const txt = this.pDI18n('PLD_COPY');
            return `<a href="javascript:onclick=window.open('${url}','copyMallProductWin','${centerWinOptions(
              888,
              610,
            )}')">${txt}</a>`;
          }

          return '';
        },
      },
      { header: this.pDI18n('PLD_SHOPPING_MALL'), name: 'mallName', minWidth: 100, align: 'center' }, //
      {
        header: this.pDI18n('PLD_PRODUCT_NUMBER'), //
        name: 'mallProductNo',
        minWidth: 110,
        align: 'center',
        formatter: this.getProductDetailUrl,
      },
      {
        header: this.pDI18n('PLD_PRODUCT_NAME'), //
        name: 'productName',
        minWidth: 200,
        align: 'left',
        onAfterChange: this.productNameOnChange,
        editor: {
          type: ProductNameEditor,
        },
        formatter: ({ value, row }: any): string => {
          return productNameConvertor(value, row);
        },
      },
      {
        header: this.pDI18n('PRODUCT_IMAGE'),
        name: 'mainImageUrl',
        minWidth: 200,
        align: 'center',
        hidden: true,
        formatter: ({ row }): string => {
          const { mainImageUrl, productName } = row;

          return mainImageUrl
            ? `<img src="${mainImageUrl}" class="product-image" alt="${productName} 상품 이미지">`
            : '-';
        },
      },
      { header: this.pDI18n('PLD_PRODUCT_MANAGEMENT_CODE'), name: 'productManagementCd', minWidth: 120, align: 'left' }, //
      {
        header: this.pDI18n('PLD_BRAND'), //
        name: 'brandName',
        minWidth: 120,
        align: 'left',
        formatter: ({ value }: any): string => {
          return escapeHtml(value);
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SALES_METHOD'), //
        name: 'saleMethodType',
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): string => {
          if (value === 'PURCHASE') {
            return this.pDI18n('PLD_BUY'); //
          } else if (value === 'CONSIGNMENT') {
            return this.pDI18n('PLD_CONSIGNMENT'); //
          }
          return '';
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_GROUP_MANAGEMENT_CODE'), //
        name: 'groupManagementCode',
        minWidth: 120,
        align: 'center',
        formatter: ({ value }: any): string => {
          return value || '-';
        },
      },
      { header: this.pDI18n('PLD_PARTNER'), name: 'partnerName', align: 'left' }, //
      { header: this.pDI18n('PLD_MANAGER'), name: 'adminName', align: 'center' }, //
      {
        header: this.pDI18n('PLD_COMMISSION_RATE'), //
        name: 'commissionRate',
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.saleMethodType === 'PURCHASE' || row.commission.type === 'PURCHASE_PRICE') {
            return '-';
          }

          return `${row.commission.rate}%`;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SUPPLY_PRICE'), //
        name: 'supplyPrice',
        align: 'center',
        formatter: ({ value, row }: any): string => {
          // 판매방식 사입 -> '-'출력 , 판매수수료 설정한경우(공급가 입력이 아닌 경우) 공급가 노출,  판매방식-위탁, 판매수수료-공급가입력, 옵션없음 일 경우 입력한 공급가 출력, 옵션 있을 경우 상세보기 팝업 출력,
          //옵션 있고, 판매방식 사입
          if (row.saleMethodType === 'PURCHASE') {
            return '-';
          }
          //판매수수료 설정한경우(공급가 입력이 아닌 경우) 계산한 공급가 노출,
          if (row.commission.type !== 'PURCHASE_PRICE') {
            return getCurrency(value);
          }
          // 판매방식-위탁, 판매수수료-공급가입력, 옵션없음 일 경우
          if (row.saleMethodType === 'CONSIGNMENT' && row.commission.type === 'PURCHASE_PRICE' && !row.hasOption) {
            return getCurrency(value);
          }
          // 옵션 있음 일 경우
          if (row.hasOption) {
            return `<a href="#" class="gridHasOption" data-mall-product-no="${row.mallProductNo}">${this.pDI18n(
              'PLD_DETAIL',
            )}</a>`;
          }
          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        },
        // copyOptions: {
        //   useFormattedValue: true
        // }
      },
      {
        header: this.pDI18n('PLD_PURCHASE_PRICE'), //
        name: 'purchasePrice',
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.saleMethodType === 'CONSIGNMENT') {
            return '-';
          }
          return getCurrency(row.purchasePrice, this.USMallNos.includes(row.mallNo));
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        // Alpha test mallProductNo:
        // 101919755, 101919760, 101919528, 101920430, 101919836, 101920180
        // "FINISHED", "AFTER_APPROVAL_READY", "APPROVAL_READY", "SALE_AGREEMENT_READY", "REGISTRATION_READY", "AFTER_APPROVAL_REJECTION"
        // "APPROVAL_READY": 101920446, 101920436, 101920431, 101920351, 101920007, 101919983, 101919892, 101919890, 101919889, 101919887, 101919886, 101919885, 101919884, 101919883, 101919882, 101919881, 101919873, 101919867, 101919860, 101919843, 101919823, 101919822, 101919821, 101919819, 101919818, 101919817, 101919815, 101919814, 101919813, 101919812, 101919795, 101919784, 101919758, 101919528
        header: this.pDI18n('PLD_APPROVAL_STATUS'), //
        name: 'applyStatusType',
        minWidth: 120,
        align: 'center',
        ignored: true,
        //  applyStatusType's value:
        //  승인상태, Enum: [ REGISTRATION_READY: 등록대기,
        //  APPROVAL_READY: 승인대기,
        //  APPROVAL_REJECTION: 승인거부,
        //  SALE_AGREEMENT_READY: 판매합의대기,
        //  SALE_AGREEMENT_REJECTION: 판매합의거부,
        //  FINISHED: 승인완료,
        //  AFTER_APPROVAL_READY: 수정 후 승인대기,
        //  AFTER_APPROVAL_REJECTION: 수정 후 승인거부 ]
        formatter: ({ value, row }: any): any => {
          let text = '';
          switch (value) {
            case 'REGISTRATION_READY':
              text = this.pDI18n('PLD_WAITING_FOR_REGISTRATION'); //
              break;
            case 'APPROVAL_READY': //2 window size need adjustment.
              text = this.pDI18n('PLD_WAITING_FOR_APPROVAL'); //
              return `<a href="javascript:onclick=window.open('/product/judgement/${
                row.mallProductNo
              }','approvalReady','${centerWinOptions(795, 950)}')">${text}</a>`;
            case 'APPROVAL_REJECTION': //1 need query data to pop
              text = this.pDI18n('PLD_REJECTION_OF_APPROVAL'); //
              const $a = $(
                `<a class="judgementRejectBtn" href="#" data-mallproductno="${row.mallProductNo}" data-commissiontype="${row.commission.type}">${text}</a>`,
              );
              return $a.prop('outerHTML');
            case 'SALE_AGREEMENT_READY': //3
              text = this.pDI18n('PLD_WAITING_FOR_SALES_AGREEMENT'); //
              // return `<a href="javascript:onclick=window.open('/product/judgement/${row.mallProductNo}','saleAgreement','${centerWinOptions(888, 610)}')">${text}</a>`;
              break;
            case 'SALE_AGREEMENT_REJECTION': //1 need query data to pop
              text = this.pDI18n('PLD_REJECTION_OF_SALES_AGREEMENT'); //
              // return `<a href="javascript:onclick=window.open('/product/judgement/${row.mallProductNo}','saleAgreement','${centerWinOptions(888, 610)}')">${text}</a>`;
              return $(
                `<a class="viewAgreementRejectBtn" href="#" data-mallproductno="${row.mallProductNo}">${text}</a>`,
              ).prop('outerHTML');
            case 'AFTER_APPROVAL_READY': //2 window size need adjustment.
              text = this.pDI18n('PLD_WAITING_FOR_APPROVAL_AFTER_MODIFICATION'); //
              return `<a href="javascript:onclick=window.open('/product/judgement/${
                row.mallProductNo
              }','approvalReady','${centerWinOptions(888, 610)}')">${text}</a>`;
            case 'AFTER_APPROVAL_REJECTION': //1  need query data to pop from rowdata.
              text = this.pDI18n('PLD_REJECT_APPROVAL_AFTER_MODIFICATION'); //
              return $(
                `<a class="judgementRejectBtn" href="#" data-mallproductno="${row.mallProductNo}" data-commissiontype="${row.commission.type}">${text}</a>`,
              ).prop('outerHTML');
            default:
              text = this.pDI18n('PLD_APPROVAL_COMPLETED'); //
              break;
          }
          return text;
        },
        copyOptions: {
          customValue: (value): string => {
            const applyStatusType = this.applyStatusType.find((item): boolean => item.value === value);
            return applyStatusType ? applyStatusType.label : '';
          },
        },
      },
      {
        // header: '판매상태',
        header: this.pDI18n('PLD_SALES_STATUS'),
        name: 'saleStatusType',
        width: 160,
        align: 'center',
        editOptions: {
          type: 'text',
        },
        formatter: (rowData: any): string => {
          const { value, row } = rowData;
          if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
            return '-';
          }
          const saleStatus = this.saleStatusList
            .concat([{ value: 'PRE_APPROVAL_STATUS', label: this.pDI18n('PLD_BEFORE_APPROVAL_COMPLETION') }])
            .find((item: any): boolean => item.value === value);
          return saleStatus ? (saleStatus.value === 'PRE_APPROVAL_STATUS' ? '-' : saleStatus.label) : '';
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        // header: '판매설정',
        header: this.pDI18n('PLD_SALES_SETTING_STATUS'),
        name: 'saleSettingStatusType',
        width: 160,
        align: 'center',
        editOptions: {
          type: 'text',
        },
        formatter: (rowData: any): string => {
          const { value, row } = rowData;
          if (row.saleStatusType === 'END_SALE') {
            return '-';
          }

          const selectBox = $('<select />', {
            class: 'gridSaleSettingStatusType',
            'data-mall-product-no': row.mallProductNo,
            'data-mall-no': row.mallNo,
            'data-row-key': row.rowKey,
            'data-original-value': value,
            'data-front-display-yn': row.frontDisplayYn,
            disabled: value === 'PROHIBITION_SALE',
          });

          $.each(
            {
              AVAILABLE_FOR_SALE: this.pDI18n('PLD_ON_SALEON_RESERVATION_SALE'), //
              STOP_SELLING: this.pDI18n('PLD_STOP_SELLING'), //
              PROHIBITION_SALE: this.pDI18n('PLD_PROHIBITION_OF_SALE'), //
            },
            (key, text): any => {
              $(selectBox).append(
                $('<option></option>')
                  .attr('value', key)
                  .attr('selected', value === key ? 'selected' : null)
                  .text(text),
              );
            },
          );

          return selectBox.prop('outerHTML');
        },
        // copyOptions: {
        //   customValue: (value): string => {
        //     const saleSettingStatusType = this.saleSettingStatusList.find((item): boolean => item.value === value);
        //     return saleSettingStatusType ? saleSettingStatusType.label : '';
        //   }
        // }
      },
      {
        header: this.pDI18n('PLD_EXHIBITION_STATUS'), //
        name: 'frontDisplayable',
        minWidth: 160,
        align: 'center',
        formatter: (rowData: any): string => {
          const { value, row } = rowData;
          const selectBox = $('<select />', {
            class: 'gridFrontDisplayYn',
            'data-mall-product-no': row.mallProductNo,
            'data-mall-no': row.mallNo,
            'data-row-key': row.rowKey,
            'data-original-value': value,
            disabled: row.saleSettingStatusType === 'PROHIBITION_SALE',
          });

          $.each(
            {
              Y: this.pDI18n('PLD_DISPLAY_POSSIBLE'), //
              N: this.pDI18n('PLD_NO_EXHIBITION'), //
            },
            (key, text): any => {
              $(selectBox).append(
                $('<option></option>')
                  .attr('value', key)
                  .attr('selected', (key === 'Y') === value ? 'selected' : null)
                  .text(text),
              );
            },
          );
          return selectBox.prop('outerHTML');
        },
        // copyOptions: {
        //   customValue: (value): string => {
        //     return value ? this.pDI18n('PLD_DISPLAY_POSSIBLE') : this.pDI18n('PLD_NO_EXHIBITION');
        //   }
        // }
      },
      {
        header: this.pDI18n('PLD_FRONT_UNEXPOSED'), //
        //old name: 'urlDirectDisplayYn',
        name: 'onlyAccessUrl',
        minWidth: 160,
        align: 'center',
        // onAfterChange(ev: any): void {
        //   //boolean to string
        //   if (String(ev.prevValue) === ev.value) return;
        //   //to do
        // },
        // editor: {
        //   type: OnlyAccessUrlSelector,
        //   options: {
        //     listItems: [
        //       {text: '프론트 노출', value: 'true'},
        //       {text: '프론트 미노출', value: 'false'}
        //     ]
        //   }
        // },
        formatter: (rowData: any): string => {
          const { value, row } = rowData;

          const selectBox = $('<select />', {
            class: 'onlyAccessUrl',
            'data-mall-product-no': row.mallProductNo,
            'data-mall-no': row.mallNo,
            'data-row-key': row.rowKey,
            'data-original-value': value,
            disabled: row.saleSettingStatusType === 'PROHIBITION_SALE',
          });

          $.each(
            {
              N: this.pDI18n('PLD_FRONT_EXPOSURE'), //
              Y: this.pDI18n('PLD_FRONT_UNEXPOSED'), //
            },
            (key, text): any => {
              $(selectBox).append(
                $('<option></option>')
                  .attr('value', key)
                  .attr('selected', (key === 'Y') === value ? 'selected' : null)
                  .text(text),
              );
            },
          );
          return selectBox.prop('outerHTML');
        },
        // copyOptions: {
        //   customValue: (value): string => {
        //     return value ? this.pDI18n('PLD_FRONT_EXPOSURE') : this.pDI18n('PLD_FRONT_UNEXPOSED');
        //   }
        // }
      },
      {
        header: this.pDI18n('PLD_MEMBERSHIP_LEVEL_EXPOSURE'), //
        name: 'memberGradeDisplayInfo',
        minWidth: 100,
        align: 'center',
        renderer: {
          type: MemberGradeDisplayInfoRenderer,
          options: {},
        },
        // copyOptions: {
        //   customValue: (value): string => {
        //     return value.check ? window.$t('PRODUCT_PRODUCTLIST_NOT_SET') : window.$t('PRODUCT_PRODUCTLIST_VIEW_SETTINGS');
        //   }
        // }
      },
      {
        header: this.pDI18n('PLD_MEMBER_GROUP_EXPOSURE'), //
        name: 'memberGroupDisplayInfo',
        minWidth: 100,
        align: 'center',
        renderer: {
          type: MemberGroupDisplayInfoRenderer,
          options: {},
        },
        // copyOptions: {
        //   customValue: (value): string => {
        //     return value.check ? window.$t('PRODUCT_PRODUCTLIST_NOT_SET') : window.$t('PRODUCT_PRODUCTLIST_VIEW_SETTINGS');
        //   }
        // }
      },
      {
        header: this.pDI18n('PLD_PRE_ORDER_PERIOD'), //
        name: 'reservationPeriod',
        minWidth: 250,
        align: 'center',
        formatter: ({ value }: any): string => {
          if (value && value.startYmdt && value.endYmdt) {
            return `${value.startYmdt} ~ ${value.endYmdt}`;
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SALES_PERIOD'), //
        name: 'salePeriod',
        minWidth: 250,
        align: 'center',
        formatter: ({ value }: any): string => {
          if (value && value.startYmdt && value.endYmdt) {
            return `${value.startYmdt} ~ ${value.endYmdt}`;
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_PRICE'), //
        name: 'salePrice',
        align: 'right',
        formatter: ({ value, row }: any): string => {
          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_IMMEDIATE_DISCOUNT'), //
        // name: 'immediateDiscountValue',
        name: 'immediateDiscountAmount',
        align: 'right',
        // immediateDiscountAmount
        //!!!use amount {"unitType":"AMOUNT","amount":0.00,"per
        formatter: ({ value, row }: any): string => {
          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_DISCOUNT_APPLICABLE_PRICE'), //
        // name: 'discountApplyPrice',
        name: 'appliedImmediateDiscountPrice',
        align: 'right',
        // appliedImmediateDiscountPrice
        formatter: ({ value, row }: any): string => {
          const val = getCurrency(value, row.countryCd === 'US');
          if (parseInt(val, 10) <= 0) {
            return '0';
          }
          return val;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_ADDITIONAL_DISCOUNT'), //
        name: 'additionalDiscountAmount',
        align: 'right',
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_ADDITIONAL_DISCOUNT_APPLICABLE'), //
        name: 'appliedAdditionalDiscountPrice',
        align: 'right',
        formatter: ({ value, row }: any): string => {
          const val = getCurrency(value, row.countryCd === 'US');
          if (parseInt(val, 10) <= 0) {
            return '0';
          }
          return val;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_RESERVE_STOCK_QUANTITY'), //
        name: 'reservationStockCnt',
        minWidth: 100,
        align: 'right',
        formatter: ({ row }: any): string => {
          if (!row.reservationPeriod) {
            return '-';
          } else {
            // return getStockCntColumnValue(row.productStock.representCnt, row.reservationStockCnt, row.optionType, row.isSoldOut);
            const reservationStockCnt = row.reservationStockCnt;
            if (reservationStockCnt) {
              return reservationStockCnt;
            } else {
              return this.pDI18n('SOLD_OUT');
            }
          }
          //test params: 101919758,101919836,101919984,101919930,101920263,101920298,101919718,101919758,101919836,101919984,101919930,101920263,101920298,101919822
          // old api: representReservationStockCnt(reservationStockCnt)
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_INVENTORY_QUANTITY_SALEABLE_INVENTORY'), //
        name: 'stockCnt',
        minWidth: 100,
        align: 'right',
        editOptions: { type: 'text', useViewMode: true },
        formatter: ({ row }: any): string => {
          // return row.productStock.safetyStockCnt;
          // return getStockCntColumnValue(row.productStock.representCnt, row.productStock.totalCnt, row.optionType, row.isSoldOut);
          // old api: representStockCnt(stockCnt)
          // new api: representCnt(productStock.totalCnt)
          // const representCnt = row.productStock.representCnt;
          const totalCnt = row.productStock.totalCnt;
          if (totalCnt) {
            return totalCnt;
          } else {
            return this.pDI18n('SOLD_OUT');
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_WAITING_FOR_DELIVERY'), //
        name: 'deliveryWaitingStockCnt',
        align: 'right',
        formatter: ({ row }: any): string => {
          return row.productStock.deliveryWaitingStockCnt;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SALES_QUANTITY'), //
        name: 'saleCnt',
        align: 'right',
        formatter: ({ row }: any): string => {
          return row.productStock.totalSaleCnt;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_OPTION'), //
        name: 'optionBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.applyStatusType === 'REGISTRATION_READY') {
            return '-';
          }

          let text = this.pDI18n('PLD_MODIFY'); //
          if (row.hasOption) {
            if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
              text = this.pDI18n('PLD_EXAMPLE'); //
            } else if (row.saleStatusType === 'REGISTRATION_READY') {
              return '-';
            }
          } else {
            return '-';
          }
          const {
            mallProductNo,
            saleMethodType,
            saleStatusType,
            saleSettingStatusType,
            mallNo,
            salePrice,
            countryCd,
            optionType,
            partnerNo,
            deliveryTemplateNo,
            hasOption,
            appliedImmediateDiscountPrice,
          } = row;
          const params: any = {
            mallProductNo,
            saleMethodType,
            saleStatusType,
            saleSettingStatusType,
            mallNo,
            salePrice,
            countryCd,
            optionType,
            partnerNo,
            deliveryTemplateNo,
            hasOption,
            appliedImmediateDiscountPrice,
            commissionRate: row.commission.rate,
            commissionRateType: row.commission.type,
            isDirectSave: true,
            useReservationStock: row.reservationPeriod ? true : false,
          };
          if (row.isStockSync) {
            params.isStockSync = row.isStockSync;
            params.masterYn = row.parentMallProductNo ? 'N' : 'Y';
          }
          return `<a href="javascript:onclick=window.open('/option/addForm?${$.param(
            params,
          )}','deliveryWaitingStockCntWin','${centerWinOptions(1222, 711)}');" class="gridModifyOption">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_ADDITIONAL_PRODUCTS'), //
        name: 'additionalProductBtn',
        minWidth: 70,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.applyStatusType === 'REGISTRATION_READY') {
            return '-';
          }

          let text = this.pDI18n('PLD_MODIFY'); //
          if (parseInt(row.additionalDiscountAmount) > 0) {
            if (row.saleSettingStatusType === 'PROHIBITION_SALE' || row.saleStatusType === 'END_SALE') {
              text = this.pDI18n('PLD_EXAMPLE'); //
            } else if (row.saleStatusType === 'REGISTRATION_READY') {
              return '-';
            }
          } else {
            return '-';
          }

          return `<a href="javascript:;" class="gridModifyAdditionalProduct" data-row-key="${row.rowKey}">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_APPLY_PROMOTION'), //
        name: 'canPromotion',
        minWidth: 100,
        align: 'center',
        formatter: ({ value, row }: any): string => {
          const currentValue = value ? 'Y' : 'N';

          if (row.saleSettingStatusType === 'PROHIBITION_SALE' || row.saleStatusType === 'END_SALE') {
            return currentValue;
          }

          return `<a href="javascript:onclick=window.open('/product/popup/modifyPromotion/${
            row.mallProductNo
          }', 'modifyPromotion', '${centerWinOptions(795, 208)}')">${currentValue}</a>`;
        },
        copyOptions: {
          customValue: (value): string => {
            return value ? 'Y' : 'N';
          },
        },
      },
      {
        header: this.pDI18n('PLD_IMAGE_INFORMATION'), //
        name: 'imageUrl',
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.applyStatusType === 'REGISTRATION_READY') {
            return '-';
          }

          let text = this.pDI18n('PLD_MODIFY'); //
          let addParam = 'false';

          if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
            text = this.pDI18n('PLD_EXAMPLE'); //
            addParam = 'true';
          }
          const url = `/product/popup/edit/${row.mallNo}/${row.mallProductNo}/images/${addParam}`;
          return `<a href="javascript:onclick=window.open('${url}','imageUrlWin','${centerWinOptions(
            1090,
            680,
          )}')">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_PRODUCT_INFORMATION_NOTICE'), //
        name: 'productDuty',
        minWidth: 100,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.saleStatusType === 'REGISTRATION_READY') {
            return '-';
          }

          let text = this.pDI18n('PLD_MODIFY'); //
          if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
            text = this.pDI18n('PLD_EXAMPLE'); //
            return `<a href="javascript:onclick=window.open('${'/productDuty/readForm?mallProductNo=' +
              row.mallProductNo}','productDutyWin','${centerWinOptions(1085, 830)}')">${text}</a>`;
          }
          return `<a href="javascript:onclick=window.open('${'/productDuty/modifyForm?mallProductNo=' +
            row.mallProductNo}','productDutyWin','${centerWinOptions(1085, 830)}')">${text}</a>`;
        },
      },
      //??? comparingPriceSite
      {
        header: this.pDI18n('PLD_REGISTER_PRICE_COMPARISON_SITE'), //
        name: 'priceComparisonSite',
        minWidth: 110,
        align: 'center',
        formatter: ({ value: { check }, row }: any): string => {
          if (row.saleStatusType === 'REGISTRATION_READY') {
            return '-';
          }

          const siteYn = check === 'NONE' ? 'N' : 'Y';
          if (row.saleSettingStatusType === 'PROHIBITION_SALE' || row.saleStatusType === 'END_SALE') {
            return siteYn;
          }

          return `<a href="javascript:onclick=window.open('/product/popup/comparingPriceSite/${
            row.mallProductNo
          }', 'priceComparisonSite', '${centerWinOptions(1045, 213)}')">${siteYn}</a>`;
        },
        copyOptions: {
          customValue: (value): string => {
            return JSON.stringify(value);
          },
        },
      },
      {
        header: this.pDI18n('PLD_PRODUCT_INFORMATION_CHANGE_HISTORY'), //
        name: 'changeHistory',
        minWidth: 120,
        align: 'center',
        formatter: ({ row }: any): string => {
          //window open get https://docs.e-ncp.com/admin?urls.primaryName=product-api#/%5BInspection%5D/%EC%83%81%ED%92%88%20%EB%B3%80%EA%B2%BD%20%ED%9E%88%EC%8A%A4%ED%86%A0%EB%A6%AC%20%EC%A1%B0%ED%9A%8C%20API
          return `<a href="javascript:;" class="gridProductChangeHistory"  data-mallproductno="${
            row.mallProductNo
          }">${this.pDI18n('PLD_EXAMPLE')}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_EXHIBITION_CATEGORY'), //
        name: 'displayCategoryNames',
        minWidth: 250,
        align: 'left',
        formatter: ({ value, row }: any): any => {
          if (!value[0]) {
            return null;
          }
          const url = `/product/popup/displayCategoryInfo?mallProductNo=${row.mallProductNo}`;
          return `<a href="javascript:onclick=window.open('${url}','displayCategoryNamesWin','${centerWinOptions(
            540,
            240,
          )}')">${value[0]}</a>`;
        },
        copyOptions: {
          customValue: (value): string => {
            if (!value[0]) {
              return '';
            }
            return value[0];
          },
        },
      },
      {
        header: this.pDI18n('PLD_PRODUCT_GROUP'), //
        name: 'groupType',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): any => {
          switch (value) {
            case 'DELIVERY':
              return this.pDI18n('PLD_GT_DELIVERY'); //
            case 'SERVICE':
              return this.pDI18n('PLD_GT_SERVICE'); //
            default:
              return '';
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_DELIVERY_STATUS'), //
        // name: 'deliveryYn',
        name: 'deliverable',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): string => {
          if (value === true) {
            return this.pDI18n('PLD_DELIVERY'); //
          }

          return this.pDI18n('PLD_NO_DELIVERY'); //
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_CLASSIFICATION'), //
        name: 'shippingAreaType',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): string => {
          if (!value) return '';
          switch (value) {
            case 'PARTNER_SHIPPING_AREA':
              return this.pDI18n('PLD_PARTNER_DELIVERY'); //
            case 'MALL_SHIPPING_AREA':
              return this.pDI18n('PLD_SHOPPING_MALL_SHIPPING'); //
            default:
              return this.pDI18n('PLD_ALL'); //
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_COST_TYPE'), //
        name: 'deliveryFeeType',
        minWidth: 120,
        align: 'center',
        ignored: true,
        // deliveryFeeType  Enum: [ FREE: 무료, CONDITIONAL: 조건부 무료, FIXED_FEE: 유료(고정 배송비) ]
        formatter: ({ value, row }: any): string => {
          if (!row.deliverable) return '';
          if (!value) return '';
          switch (value) {
            case 'CONDITIONAL':
              return `${this.pDI18n('PLD_CONDITIONALLY_FREE')}(${getCurrency(
                row.freeShippingConditionAmount,
                this.USMallNos.includes(row.mallNo),
              )})`;
            case 'FIXED_FEE':
              return this.pDI18n('PLD_PAID_FIXED_SHIPPING_FEE'); //
            default:
              return this.pDI18n('PLD_FREE'); //
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_FEE'), //
        name: 'deliveryCharge',
        minWidth: 80,
        align: 'center',
        ignored: true,
        formatter: ({ value, row }: any): string => {
          if (!row.deliverable) {
            return '';
          }

          if (!value) {
            return '0';
          }

          return getCurrency(value, this.USMallNos.includes(row.mallNo));
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('DELIVERY_DUE_DATE'), //
        name: 'usesDeliveryDueDate',
        align: 'center',
        ignored: true,
        formatter: ({ row }: any): string => {
          if (row.deliverable) {
            const url = `/product/popup/edit/${row.mallProductNo}/delivery-date`;
            return `<a href="javascript:onclick=window.open('${url}','deliveryDate','${centerWinOptions(
              1123,
              490,
            )}')">${row.usesDeliveryDueDate ? 'Y' : 'N'}</a>`;
          }
          return '-';
        },
      },
      {
        header: this.pDI18n('PLD_BUNDLED_SHIPPING'), //
        name: 'shippingCombinable',
        align: 'center',
        ignored: true,
        formatter: ({ value, row }: any): string => {
          if (row.deliverable) {
            return value ? 'Y' : 'N';
          }
          return '-';
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_DELETE_REQUEST'), //
        name: 'deleteBtn',
        minWidth: 70,
        align: 'center',
        formatter: ({ row }: any): string => {
          //parnter need add judge:
          // if (row.applyStatusType === 'REGISTRATION_READY') {
          //   return `<button class="deleteMallProduct" data-mall-no="${row.mallNo}" data-mall-product-no="${row.mallProductNo}">삭제</button>`;
          // }
          // if (row.saleStatusType !== 'ON_SALE' && !this.doNotDeleteProduct.includes(row.applyStatusType)) {
          //   return `<button class="deleteMallProduct" data-mall-no="${row.mallNo}" data-mall-product-no="${row.mallProductNo}">삭제</button>`;
          // }
          if (row.deletable) {
            return `<button class="deleteMallProduct" data-mall-no="${row.mallNo}" data-mall-product-no="${
              row.mallProductNo
            }">${this.pDI18n('PLM_DELETE')}</button>`;
          }

          return '-';
        },
      },
    ],
    rowHeaders: ['checkbox'],
    pageOptions: {
      page: 1,
      totalCount: 0,
      perPage: 100,
    },
  };

  public gridPropsOfStockSync: any = {
    columns: [
      ...this.gridProps.columns.slice(0, 3),
      {
        header: this.pDI18n('PLD_PRODUCT_NUMBER'), //
        name: 'mallProductNo',
        minWidth: 110,
        align: 'center',
        formatter: ({ value, row }: any): string => {
          if (row.isStockSync) {
            if (row.parentMallProductNo === 0) {
              return `(M) ${value}`;
            }
            return `(S) ${value}`;
          }

          return value;
        },
      },
      ...this.gridProps.columns.slice(4),
    ],
    rowHeaders: ['checkbox'],
  };

  public gridOptions?: { [propName: string]: any } = {
    id: 'tui-grid-productlist',
    columnOptions: {
      minWidth: 70,
      resizable: true,
      frozenCount: 5,
    },
    bodyHeight: 500,
    // bodyHeight: 700,
    rowHeight: 31,
    // virtualScrolling: true,
    minRowHeight: 35,
    // keyColumnName: 'mallProductNo', //!!!!!!!!!!!!!scroll grid data issue!!!!
    displayRowCount: 20,
    isInitialRequest: true,
    useClientSort: false,
    // copyOptions: {
    //   useFormattedValue: true,
    //   useListItemText: true
    // },
    heightResizable: true,
    // under props need further confirmation!!!!!!
    // pagination: {
    //   itemsPerPage: $('#pageSize').val(),
    //   visiblePages: 10
    // }
  };

  public gridOptionsOfStockSync = {
    id: 'tui-grid-productlistOfStockSync',
    columnOptions: {
      minWidth: 70,
      resizable: true,
      frozenCount: 5,
    },
    rowHeight: 31,
    minRowHeight: 35,
    displayRowCount: 20,
    isInitialRequest: true,
    useClientSort: false,
    heightResizable: true,
  };

  public rejectReasonInfoObj: { [propName: string]: string } = {
    BASIC_INFO: this.pDI18n('PLD_BASIC_INFORMATION'),
    SALE_INFO: this.pDI18n('PLD_SALES_INFORMATION'),
    IMAGE_INFO: this.pDI18n('PLD_IMAGE_INFORMATION'),
    DELIVERY_INFO: this.pDI18n('PLD_SHIPPING_INFORMATION'),
    ETC_INFO: this.pDI18n('PLD_SEPARATE_APPROVAL_REJECTION_OPINION'),
  }; //

  public stockSyncIsShow = false;
  public stockSyncData = [];
}
